/**
* A service that allows interactions with the ITSO Registration microservice
*/
export class ItsoRegistrationService {
  private itsoRegistrationsResource: InterACT.Interfaces.IResource<InterACT.Interfaces.ItsoRegistrations.RegistrationsResponse>;

  constructor(private $resource: ng.resource.IResourceService) {
    this.itsoRegistrationsResource = $resource('api/itso-registrations');
  }

  /**
   * Calls the itso registration microservice to get list of as many registrations as possible
   *
   * @param query The query to run against the itso registration service
   *
   * @returns a promise that resolves with an ITSO registration response
   */
  public getItsoRegistrations(query?: string) {
    return this.itsoRegistrationsResource.get({ limit: 10000, offset: 0, q: query }).$promise;
  }
}